var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ClientService from '../../../api/ClientService';
import CommonService from '../../../api/CommonService';
import RegexStr from "../../../common/RegexStr";
import { ESendCodeType } from "../../../enum/ESendCodeType";
var phoneRegex = new RegExp(RegexStr.mobile);
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phone = '';
        _this.code = '';
        _this.invite_code = '';
        _this.group = null;
        _this.groups = [];
        _this.invite_code_list = [];
        _this.isValid = false;
        _this.timer = null;
        _this.remainTime = 60;
        _this.canGetCode = true;
        _this.bindCheckFlag = true;
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getGroups();
    };
    AddDialog.prototype.getGroups = function () {
        var _this = this;
        this.service.getGroups().then(function (res) {
            var data = res.data.data;
            _this.groups = data || [];
            if (data && data.length) {
                _this.group = data[0].group_id;
            }
        });
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        if (!this.invite_code) {
            this.$message.error("请输入邀请码");
            return;
        }
        ;
        var params = {
            invite_code: this.invite_code,
            group_id: this.group
        };
    };
    AddDialog.prototype.validatePhone = function () {
        var _this = this;
        var phoneRegex = /^1[23456789]\d{9}$/;
        if (phoneRegex.test(this.phone)) {
            this.commonService.bindCheck({ phone: this.phone }).then(function (res) {
                _this.bindCheckFlag = false;
            }, function (error) {
                _this.bindCheckFlag = true;
                _this.$message.error(error.message);
            });
        }
    };
    AddDialog.prototype.validateCode = function () {
        var _this = this;
        if (this.code.length > 6) {
            this.code = this.code.slice(0, 6);
        }
        if (this.code.length === 6) {
            this.commonService.verifyCode({ phone: this.phone, sms_code: this.code, type: ESendCodeType.add }).then(function (res) {
                _this.invite_code_list = res.data.data.invite_code_list;
                _this.isValid = true;
                _this.clearTimer();
            }, function (error) {
                _this.$message.error(error.message);
            });
        }
    };
    AddDialog.prototype.sendCode = function () {
        var _this = this;
        if (this.timer)
            return;
        if (!phoneRegex.test(this.phone)) {
            this.$message.error('手机号格式不正确！');
            return;
        }
        this.commonService.sendCode({ phone: this.phone, type: ESendCodeType.add }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
        this.canGetCode = false;
        this.isValid = false;
        this.timer = setInterval(function () {
            _this.remainTime--;
            if (_this.remainTime === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    AddDialog.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    AddDialog = __decorate([
        Component
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
